export interface MergeField {
  key: string;
  label: string;
  description: string;
  example: string;
  category: 'lead' | 'sender' | 'date' | 'system';
}

export const CAMPAIGN_MERGE_FIELDS: MergeField[] = [
  { key: 'lead_name', label: 'Lead Name', description: 'Name of the lead/business', example: 'Acme Corp', category: 'lead' },
  { key: 'lead_email', label: 'Lead Email', description: 'Primary email of the lead', example: 'info@acme.com', category: 'lead' },
  { key: 'lead_phone', label: 'Lead Phone', description: 'Phone number', example: '+1 555-0123', category: 'lead' },
  { key: 'lead_address', label: 'Lead Address', description: 'Address of the lead', example: '123 Main St', category: 'lead' },
  { key: 'lead_category', label: 'Lead Category', description: 'Business category', example: 'Restaurant', category: 'lead' },
  { key: 'lead_website', label: 'Lead Website', description: 'Website URL', example: 'www.acme.com', category: 'lead' },
  { key: 'lead_status', label: 'Lead Status', description: 'Current lead status', example: 'qualified', category: 'lead' },
  { key: 'sender_name', label: 'Sender Name', description: 'Name of the email sender', example: 'John Doe', category: 'sender' },
  { key: 'sender_email', label: 'Sender Email', description: 'Email of the sender', example: 'john@company.com', category: 'sender' },
  { key: 'sender_company', label: 'Sender Company', description: 'Company name', example: 'Our Company', category: 'sender' },
  { key: 'current_date', label: 'Current Date', description: 'Today\'s date', example: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }), category: 'date' },
  { key: 'unsubscribe_url', label: 'Unsubscribe URL', description: 'Auto-generated unsubscribe link', example: 'https://example.com/unsubscribe', category: 'system' },
];

export const MERGE_FIELD_CATEGORIES = [
  { key: 'lead', label: 'Lead Fields' },
  { key: 'sender', label: 'Sender Fields' },
  { key: 'date', label: 'Date Fields' },
  { key: 'system', label: 'System Fields' },
] as const;

export function replaceMergeFields(template: string, variables: Record<string, string>): string {
  let result = template;
  for (const [key, value] of Object.entries(variables)) {
    result = result.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), value || '');
  }
  return result;
}

export function getExampleVariables(): Record<string, string> {
  const vars: Record<string, string> = {};
  for (const field of CAMPAIGN_MERGE_FIELDS) {
    vars[field.key] = field.example;
  }
  return vars;
}

export function extractVariablesFromTemplate(template: string): string[] {
  const matches = template.match(/\{\{\s*(\w+)\s*\}\}/g) || [];
  return [...new Set(matches.map(m => m.replace(/[{}]/g, '').trim()))];
}
